import { defineMessages } from "react-intl";

const messages = defineMessages({
    next: {
        id: "general.next",
    },
    back: {
        id: "general.back",
    },
    homeworkClass: {
        id: "homework.class",
    },
    rememberClassId: {
        id: "homework.rememberClassId",
    },
});

export default messages;
